import React from "react";
import SystemSettingsView from "./SystemSettingsView";

const SystemSettingsContainer = () => {
  return <SystemSettingsView />;
};

export default SystemSettingsContainer;
